import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import Contest from './contest/Contest';

export default [
    <Route exact path="/configuration" render={() => <Configuration />} />,
    <Route exact path="/contest" render={() => <Contest />} />,
];
